import React                                    from 'react';
import QuoteSteps                               from 'pu-react/components/QuoteSteps';
import { START, QUOTED, PRICE_SELECTED, ERROR } from 'pu-data/QuoteSteps';

export default (props) => {
  let activeItem = 1;

  if (props.quoteStep === START || props.quoteStep === ERROR || props.parametersChanged) {
    activeItem = 1;
  } else if (props.quoteStep === QUOTED) {
    activeItem = 2;
  } else if (props.quoteStep === PRICE_SELECTED) {
    activeItem = 3;
  }

  return (
    <QuoteSteps activeItem={activeItem} {...props} />
  );
};
